import { lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";
export { previewSettings } from "./previewSettings";

// PDF.js renders every page in the browser; PbReader (Python) only supplies
// the A4 sheet layout (position/scale/rotation) — see pdfPreviewDocuments.js
// and pdfPageRenderer.js. Lazy-loaded so the PDF.js bundle stays out of the
// initial chunk for routes that never show a preview.
const PdfPreview = lazy(() => import("./PdfPreview"));

export default function PbReaderPreview(props) {
    const { t } = useTranslation();
    // Remounts (and drops any stale renderer state) on document switch or
    // re-login — see documentPool.js for the pooling this relies on.
    const key = `${props.currentDocument.id}:${localStorage.getItem("access_token") || ""}`;
    return (
        <Suspense fallback={<p role="status">{t("pbreader.loading")}</p>}>
            <PdfPreview key={key} {...props} />
        </Suspense>
    );
}
